'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { VIEW_MODE as VIEW } from '../../consts';
import {sendEvent} from '../../utils/yandexMetrika';
import {eventShowViewMap, eventShowViewPaper} from '../../app/Search/events';
import { IconViewMode, IconPrinter } from '../Icons';

const printPage = () => {
  sendEvent('search-print');
  window.print();
};

function ToggleViewMode (props) {
  const view = props.viewMode;
  const isGrid = !view || view === VIEW.grid;
  const isList = view === VIEW.paper;
  const isMap = view === VIEW.map;

  function handlerUpdateView (viewMode) {
    if (view === viewMode) {
      return false;
    }

    props.onUpdate({ viewMode });

    VIEW.paper === viewMode && eventShowViewPaper();
    VIEW.map === viewMode && eventShowViewMap();
  }

  return (
    <div className={'btn-group btn-group-view-mode ' + props.className} role='group'>
      <button
        onClick={() => handlerUpdateView(VIEW.grid)}
        type='button'
        className={'btn btn-base btn-view-mode' + (isGrid ? ' pressed' : '')}>
        <IconViewMode mode={VIEW.grid} />
        <div className="text" data-title='Подробно'>
          <span>Подробно</span>
        </div>
      </button>

      <button
        onClick={() => handlerUpdateView(VIEW.paper)}
        type='button'
        className={'btn btn-base btn-view-mode' + (isList ? ' pressed' : '')}>
        <IconViewMode mode={VIEW.paper} />
        <div className="text" data-title='Кратко'>
          <span>Кратко</span>
        </div>
      </button>

      <button
        onClick={() => handlerUpdateView(VIEW.map)}
        type='button'
        data-title='Карта'
        className={'btn btn-base btn-view-mode' + (isMap ? ' pressed' : '')}>
        <IconViewMode mode={VIEW.map} />
        Карта
      </button>

      <button
        onClick={printPage}
        title='Распечатать страницу'
        type='button'
        className={'btn btn-base btn-printer'}>
        <IconPrinter />
      </button>
    </div>
  );
}

ToggleViewMode.propTypes = {
  className: PropTypes.string,
  viewMode: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired
};

ToggleViewMode.defaultProps = {
  className: ''
};

export default ToggleViewMode;



// WEBPACK FOOTER //
// ./src/ui/Controls/ToggleViewMode.jsx